import { IGetMemberProfileDataOutput } from "../../interfaces/memberProfile/iGetMemberProfileDataOutput";

export class GetMemberProfileDataOutput implements IGetMemberProfileDataOutput {
    memberKey: string;

    constructor(memberKey: string) {
        this.memberKey = memberKey;
    }
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/memberProfile/getMemberProfileDataOutput.ts